/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryCodeResource
 */
export interface CountryCodeResource {
    /**
     * 
     * @type {string}
     * @memberof CountryCodeResource
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryCodeResource
     */
    label?: string;
}

/**
 * Check if a given object implements the CountryCodeResource interface.
 */
export function instanceOfCountryCodeResource(value: object): value is CountryCodeResource {
    return true;
}

export function CountryCodeResourceFromJSON(json: any): CountryCodeResource {
    return CountryCodeResourceFromJSONTyped(json, false);
}

export function CountryCodeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryCodeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function CountryCodeResourceToJSON(value?: CountryCodeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

